App.ClientCardComponent = Em.Component.extend
  classNames: [ 'client-card-wrap' ]

  store: Em.inject.service('store')
  env:   Em.inject.service('environment')
  session: Em.inject.service('session')

  isShown: true
  isEditing: false
  commentIsEditing: false

  isBonusesEnabled: (->
    isEnabled = false
    @get('session.availableOrganizations').forEach (o) ->
      isEnabled = !!o.get('bonus_enabled')

    isEnabled
  ).property('session.availableOrganizations')

  handleInitialShowState: (->
    cl = if @get('isShown') then 'shown' else 'hidden'
    @$('.client-card').addClass(cl)
  ).on('didInsertElement')

  # ---
  # Анимации появления/скрытия
  # ---
  onIsShownChanged: (->
    shown = @get('isShown')
    slideDuration = 200
    showDuration   = 400
    hideDuration   = 150

    if shown
      @$().slideDown(slideDuration)
      @$('.client-card').addClass('show-anim')
      @$('.client-card').removeClass('hidden')

      Em.run.later =>
        return if @get('isDestroyed')
        @$('.client-card').addClass('shown')
        @$('.client-card').removeClass('show-anim')
      , showDuration
    else
      @$().slideUp(slideDuration)

      @$('.client-card').addClass('hide-anim')
      @$('.client-card').removeClass('shown')
      Em.run.later =>
        return if @get('isDestroyed')
        @$('.client-card').addClass('hidden')
        @$('.client-card').removeClass('hide-anim shown')
      , hideDuration
  ).observes('isShown')

  # ---
  # Форматирование полей
  # ---
  registeredAt: (->
    moment(@get('client.created_at')).format('D MMMM YYYY')
  ).property('client.created_at')

  lastOrderAt: (->
    moment(@get('client.last_order_at')).format('D MMMM YYYY')
  ).property('client.last_order_at')

  birthdateAt: (->
    moment(@get('client.birthdate')).format('D MMMM YYYY')
  ).property('client.birthdate')

  recurrenceText: (->
    @get('env').translate("clients.recurrence_label.#{ @get('client.recurrence') }")
  ).property('client.recurrence')

  avatarBackground: (->
    return ''.htmlSafe() unless @get('client.avatar')
    "background-image: url(#{@get('client.avatar')})".htmlSafe()
  ).property('client')

  actions:
    toggleProperty: (property) ->
      unless Ember.isEmpty(property)
        @toggleProperty(property)
      false

    saveClient: ->
      client = @get('client')

      return if Ember.isEmpty(client)

      Ember.RSVP.resolve(client).then((client) =>
        client.save().catch(->
          client.rollback()
        ).finally(=>
          @set('commentIsEditing', false)
        )
      )

      false

    rollbackClient: ->
      client = @get('client')

      return if Ember.isEmpty(client)

      Ember.RSVP.resolve(client).then((client) ->
        client.rollback()
      )

      @set('commentIsEditing', false)

      false

    openClientRoute: ->
      @sendAction('onCardClicked', @get('client'))
      false

    addressClicked: (address) ->
      @sendAction('onAddressClicked', address)
      false
